import { OreCardContainer, OreCardWrapper, OreStack } from '@edenredespana/oreneta'
import { OreMultiSelect } from '@/Shared/ui/molecules/OreMultiSelect'

import { FilterModel, FilterResultModel } from '@/Shared/domain'
import { InputType } from '@/Shared/ui/TableSearcher'
import { useTranslation } from 'react-i18next'
import { transactionsTranslation } from '@/Transactions/ui/transactionsTranslation'
import { useUserData } from '@/User/ui/context'
import { UserType } from '@/User/domain'
interface FiltersContainerProps {
  filters: FilterModel[]
  setFilters: (filters: Array<FilterResultModel | undefined>) => void
  currentFilters: Array<FilterResultModel | undefined>
}

export const FiltersContainer = ({
  filters,
  setFilters,
  currentFilters,
}: FiltersContainerProps): JSX.Element => {
  const { t } = useTranslation()
  const { userType } = useUserData()
  
  // Localiza dinámicamente el filtro 'localCode' en todo el array
  const localCodeIndex = filters.findIndex(f => f.id === 'localCode')
  const localCodeFilter = localCodeIndex !== -1 ? filters[localCodeIndex] : undefined
  const localCodeRequiresDateRange = localCodeFilter?.requiresDateRange !== false
  
  
  const computeFilterRow = (index: number, doubleRow: boolean): JSX.Element => {
    return (
      <OreStack direction="row" placeContent="stretch" sameSize key={index}>
        <InputType
          {...filters[index]}
          setValue={setFilters}
          currentValue={currentFilters}
          index={index}
        >
          {localCodeFilter && localCodeIndex === index && Array.isArray(localCodeFilter.options) ? (
            <OreMultiSelect
              label={localCodeFilter.label}
              placeholder={localCodeFilter.placeholder}
              searchPlaceholder={t(
                userType === UserType.NURSERY
                  ? transactionsTranslation.table.filters.local.nurserySearchPlaceholder
                  : transactionsTranslation.table.filters.local.search,
              )}
              value={(currentFilters[localCodeIndex]?.value || '')
                .split(',')
                .filter(Boolean)}
              maxVisibleTags={1}
              options={(localCodeFilter.options || []).map(o => ({ value: o.value, label: o.label }))}
              disabled={localCodeRequiresDateRange &&
                (!(currentFilters.find(f => f?.name === 'beginDate')?.value) ||
                !(currentFilters.find(f => f?.name === 'endDate')?.value))}
              onChange={vals => {
                const newValue = [...currentFilters]
                newValue[localCodeIndex] = { name: localCodeFilter.id, value: vals.join(',') }
                setFilters(newValue)
              }}
            />
          ) : null}
        </InputType>
        {doubleRow ? (
          <InputType
            {...filters[index + 1]}
            setValue={setFilters}
            currentValue={currentFilters}
            index={index + 1}
          >
            {localCodeFilter && localCodeIndex === index + 1 && Array.isArray(localCodeFilter.options) ? (
              <OreMultiSelect
                label={localCodeFilter.label}
                placeholder={localCodeFilter.placeholder}
                searchPlaceholder={t(
                  userType === UserType.NURSERY
                    ? transactionsTranslation.table.filters.local.nurserySearchPlaceholder
                    : transactionsTranslation.table.filters.local.search,
                )}
                value={(currentFilters[localCodeIndex]?.value || '')
                  .split(',')
                  .filter(Boolean)}
                maxVisibleTags={1}
                options={(localCodeFilter.options || []).map(o => ({ value: o.value, label: o.label }))}
                disabled={localCodeRequiresDateRange &&
                  (!(currentFilters.find(f => f?.name === 'beginDate')?.value) ||
                  !(currentFilters.find(f => f?.name === 'endDate')?.value))}
                onChange={vals => {
                  const newValue = [...currentFilters]
                  newValue[localCodeIndex] = { name: localCodeFilter.id, value: vals.join(',') }
                  setFilters(newValue)
                }}
              />
            ) : null}
          </InputType>
        ) : null}
      </OreStack>
    )
  }

  return (
    <OreCardContainer tone="neutral-100" hasShadow={false}>
      <OreCardWrapper>
        <OreStack space="large" placeContent="stretch">
          {filters.map((_, index) => {
            if (index % 2 === 0) {
              return computeFilterRow(index, index + 1 < filters.length)
            }
            return null
          })}
        </OreStack>
      </OreCardWrapper>
    </OreCardContainer>
  )
}
